/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetPublicContactAliasesRequest} from '@cash-web/protos/squareup/cash/janus/api/AccountHolder.pb'
import {GetContactAliasesResponse} from '@cash-web/protos/squareup/cash/janus/api/AccountHolder.pb'


export const getPublicContactAliases = (request: GetPublicContactAliasesRequest, options?: CashRequestOptions) => post<GetPublicContactAliasesRequest, GetContactAliasesResponse>("/2.0/cash/get-public-contact-aliases", request, {...options, rejectOnError: true })